import React, { FC, ReactElement } from 'react';
import { useEnsureConversation } from './hooks/useEnsureConversation';
import { LoadingState } from '@zdrbm/zdr-native-tools';
import { IConversation } from '../model/Conversation';

export interface EnsureConversationProps {
    conversationId: string;
    render: (conversation: IConversation) => ReactElement;
}

export const EnsureConversationHOC: FC<EnsureConversationProps> = (props) => {
    const { conversationId, render } = props;

    const { conversation, loadingState } = useEnsureConversation(conversationId);

    let component;

    switch (loadingState) {
        case LoadingState.IDLE:
        case LoadingState.LOADING:
            component = <div>Loading...</div>;
            break;
        case LoadingState.ERROR:
            component = <div>Error</div>;
            break;
        case LoadingState.DONE:
            component = render(conversation!);
            break;
    }

    return component;
};